import DOMPurify from 'dompurify';

/**
 * Configuración estricta de elementos y atributos permitidos para plantillas de contrato.
 * Previene vulnerabilidades XSS (Cross-Site Scripting) al bloquear scripts, eventos inline (onload, onerror),
 * iframes, objetos incrustados y esquemas javascript:.
 */
export const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'b', 'strong', 'em', 'i', 'u', 's', 'del',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'ul', 'ol', 'li',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td',
    'span', 'div', 'hr', 'sub', 'sup',
  ],
  ALLOWED_ATTR: [
    'class', 'style', 'data-clave', 'data-negrita',
    'contenteditable', 'title', 'colspan', 'rowspan',
    'border', 'align', 'valign', 'width',
  ],
  ALLOW_DATA_ATTR: false,
};

/**
 * Sanitiza contenido HTML para su uso seguro en el editor de contratos y el DOM.
 * 
 * @param {string} html - Código HTML a sanitizar
 * @returns {string} HTML sanitizado y seguro
 */
export const sanitizeContractHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
};

export default sanitizeContractHtml;
